import { render, staticRenderFns } from "./AccionModificarTipoCompra.vue?vue&type=template&id=1d9e2228&scoped=true&"
import script from "./AccionModificarTipoCompra.vue?vue&type=script&lang=js&"
export * from "./AccionModificarTipoCompra.vue?vue&type=script&lang=js&"
import style0 from "./AccionModificarTipoCompra.vue?vue&type=style&index=0&id=1d9e2228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e2228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d9e2228')) {
      api.createRecord('1d9e2228', component.options)
    } else {
      api.reload('1d9e2228', component.options)
    }
    module.hot.accept("./AccionModificarTipoCompra.vue?vue&type=template&id=1d9e2228&scoped=true&", function () {
      api.rerender('1d9e2228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionModificarTipoCompra.vue"
export default component.exports